import React from "react";
import axios from "axios";
import Form from "react-validation/build/form";

import { BACKEND_CONFIG } from "../../config/consts";
import Input from "../../components/Input";
import { required, email } from "../../validation/validation";
import { ValidationProvider } from "../../validation/validation-provider";

import ResetPasswordConfirm from "./ResetPasswordConfirm";

import "../../styles/reset-password-page.scss";

export default class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      isValid: false,
      validationMessage: "",
    };

    this.formRef = React.createRef();
  }

  updateData = (e) => {
    const field = e.target.name;
    this.setState({ [field]: e.target.value });
  };

  onHandleSubmit(event) {
    let isValid = ValidationProvider.isValid(this.formRef);

    if (!isValid) {
      this.setState({ isPaymentMethodValid: false });
      return;
    }

    const { emailAddress } = this.state;
    const resetUrl = `${BACKEND_CONFIG.apiUrl}account/reset-password`;

    axios
      .post(resetUrl, { emailAddress })
      .then((result) =>
        this.setState({
          isValid: result.status === 200,
        })
      )
      .catch((error) => {
        let errorResponse = error.response;

        if (errorResponse.data.Message) {
          this.setState({
            validationMessage: errorResponse.data.Message,
          });
        }

        this.props.onServerValidationErrors(
          error.response.data.ValidationErrors
        );
      });

    event.preventDefault();
  }

  render() {
    const { isValid } = this.state;
    return (
      <div className="component reset-password-page">
        {isValid ? (
          <ResetPasswordConfirm />
        ) : (
          <div>
            <h2>
              Please enter your email address and a link will be sent to reset
              password
            </h2>
            <div className="center-box">
              <p className="text-left">
                All users logging in for the first time are required to reset
                their passwords. Enter your email below to begin.
              </p>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  return false;
                }}
                ref={this.formRef}
              >
                <div className="form-group label-static w-100">
                  <label htmlFor="emailAddress">Enter Your Email Address</label>
                  <Input
                    value={this.state.emailAddress}
                    type="email"
                    id="emailAddress"
                    name="emailAddress"
                    placeholder="Enter Your Email Address"
                    onBlur={this.updateData}
                    field="emailAddress"
                    validations={[required, email]}
                  />
                </div>
                <div className="form-group label-static w-100">
                  {this.state.validationMessage && (
                    <span className="error-message is-visible">
                      {this.state.validationMessage}
                    </span>
                  )}
                </div>
              </Form>
              <button
                className="btn btn-primary w-100 mt-1"
                onClick={(event) => this.onHandleSubmit(event)}
                type={"submit"}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
